/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'groups';

export const ipAddrgroupModalBreadcrumbTitle = `${prefix}.ipAddrgroupModalBreadcrumbTitle`;
export const stringGroupModalBreadcrumbTitle = `${prefix}.stringGroupModalBreadcrumbTitle`;

export const ENGLISH = {
    [ipAddrgroupModalBreadcrumbTitle]: 'IP Group',
    [stringGroupModalBreadcrumbTitle]: 'String Group',
};
